import { CircularProgress, Typography, WithStyles } from "@material-ui/core";
import { styles } from "./ExternalLoginView.styles";
import * as React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useAuthContext } from "../../../auth/AuthProvider";
import { CenteredContainer } from "../../components/CenteredContainer/CenteredContainer";
import { withStyles } from "@material-ui/core/styles";
import { hasCognitoDatashopRole, isUsedCognito } from "../../../utilities/userUtils";
import * as UserDetailsAction from "../../../stores/user/UserDetailsAction";
import { LogoutReason } from "../../../constants/LOGOUT";
import { ID_TOKEN, ACCESS_TOKEN, LOGIN_REDIRECT } from "../../../auth/authClient/src/constants";
import { decode } from "../../../auth/authClient/src/jwt";
import { redirectToPrevious } from "../../../utilities/generalUtils";

interface IExternalLoginViewProps extends WithStyles<typeof styles> {}

const ExternalLoginViewPure: React.FunctionComponent<IExternalLoginViewProps> = ({ classes }) => {
    const authContext = useAuthContext();
    const history = useHistory();
    const dispatch = useDispatch();
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    const idToken = localStorage.getItem(ID_TOKEN);
    const decodedAccessToken = accessToken && decode(accessToken);
    const decodedIdToken = idToken && decode(idToken);
    const userId = authContext?.user?.id || decodedAccessToken?.user.sub;
    const email = decodedIdToken?.user?.email;
    const username = decodedAccessToken?.user?.username;

    const userDetails = useSelector(state => state.userDetails.currentlyLoggedUser);
    const isLoggingIn = window.location.search.includes("code=");

    //read in the utils function
    const redirect_login = String(localStorage.getItem(LOGIN_REDIRECT));

    useEffect(() => {
        if (isUsedCognito() && userId) {
            dispatch(UserDetailsAction.requestCurrentUser(userId));
        }
    }, [dispatch, userId]);

    useEffect(() => {
        if (userDetails !== undefined && !authContext.isLoading) {
            if (userId) {
                if (isUsedCognito()) {
                    if (!hasCognitoDatashopRole(authContext)) {
                        if (userDetails === null)
                            history.push({
                                pathname: "/save-user-details",
                                state: {
                                    userId,
                                    email,
                                    username
                                }
                            });
                        else authContext.logoutWithRedirect(LogoutReason.Locked);
                    } else if (userDetails === null) authContext.logoutWithRedirect(LogoutReason.UndefinedState);
                    else if (userDetails.privacyNoticeAgreed === false) {
                        history.push({
                            pathname: "/accept-privacy-notice",
                            state: {
                                userId
                            }
                        });
                    } else if (redirectToPrevious(redirect_login)) {
                        history.replace(redirect_login);
                        localStorage.removeItem(LOGIN_REDIRECT);
                    } else history.push("/");
                }
            }
        }
        // eslint-disable-next-line
    }, [dispatch, userDetails, userId, authContext.isLoading]);

    return (
        <CenteredContainer>
            {isLoggingIn && (
                <div className={classes.loggingIn}>
                    {authContext.error === "" ? (
                        <>
                            <CircularProgress />
                            <Typography variant="h4">Logging in. Please wait...</Typography>
                        </>
                    ) : (
                        <>
                            <CircularProgress />
                        </>
                    )}
                </div>
            )}
        </CenteredContainer>
    );
};

export const ExternalLoginView = withStyles(styles)(ExternalLoginViewPure);
